export class NoShowReasonDTO {
  constructor({ reasonId } = {}) {
    this.reasonId = reasonId;
  }

  prepareNoShowReasonData() {
    return {
      reason_id: this.reasonId,
    };
  }
}
